import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';
import { useForm } from 'react-hook-form';

import { Translate } from '@core/constant';
import { useValidator } from '@core/hook';
import { SearchArticleForm, searchArticleValidator } from '@core/type';

import { FormControl } from '../FormControl';
import { InputTextControl } from './InputTextControl';
import { InputSearchArticleProps } from './interface-form-input';

export const InputSearchArticle: FC<InputSearchArticleProps> = ({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onSearch = () => {},
  ...inputProps
}: InputSearchArticleProps): JSX.Element => {
  const { t: tAria } = useTranslation(Translate.common.ARIA);
  const { t: tForm } = useTranslation(Translate.common.FORM);

  const { handleSubmit, control, trigger, reset, setError } = useForm<SearchArticleForm>({
    mode: 'onChange',
    resolver: useValidator(searchArticleValidator, tForm),
    defaultValues: {
      searchArticle: '',
    },
  });

  return (
    <FormControl
      t={tForm}
      trigger={trigger}
      reset={reset}
      handleSubmit={handleSubmit}
      setError={setError}
      fn={onSearch}
    >
      <InputTextControl
        control={control}
        name="searchArticle"
        aria-label={tAria('searchInput')}
        placeholder={tForm('searchArticle.placeholder')}
        {...inputProps}
      />
    </FormControl>
  );
};
